import { NineNavigation } from "@9amhealth/wcl/generated/react";
import styled from "@emotion/styled";
import type { FC } from "react";
import React from "react";
import { useParams } from "react-router-dom";
import { signupHeaderHeightDesktop } from "src/constants/layout";
import CustomQuestionnaire from "src/ui/components/CustomQuestionnaire/CustomQuestionnaire";
import Translate from "../Translate/Translate";

const StandaloneContent = styled.div`
  label: StandaloneContent;
  width: 100%;
  min-height: 100vh;
  min-height: 100svh;
  padding-top: ${signupHeaderHeightDesktop}px;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const StandaloneHeader: FC = () => {
  return (
    <NineNavigation
      app
      variant="stepper"
      style={{ background: `var(--color-cream)` }}
    >
      <nine-progress-bar slot="progress"></nine-progress-bar>

      <nine-overlay slot="help" variant="toast">
        <div slot="trigger" className="strong">
          <Translate msg="help.question" />
        </div>
        <div slot="content">
          <h5 className="strong m0">
            <Translate msg="help.questions" />
          </h5>
          <p className="lauf-text">
            <Translate msg="help.phoneSupport" />{" "}
            <a href="tel:2029329958">(202) 932-9958</a>
            <br />
            <Translate msg="help.emailSupport" />{" "}
            <a href="mailto:support@join9am.com">support@join9am.com</a>
          </p>
        </div>
      </nine-overlay>
    </NineNavigation>
  );
};

const StandaloneQuestionnaire: FC = () => {
  const { id = "" } = useParams<{ id: string }>();

  return (
    <div
      style={{
        display: "flex",
        backgroundColor: `var(--color-cream)`
      }}
    >
      <div style={{ width: "100%" }}>
        <StandaloneHeader />
        <StandaloneContent className="wrap-center">
          <CustomQuestionnaire
            autoSkip={false}
            showThankYouStep
            resetScrollOnEachStep
            id={id}
            useRouting
          />
        </StandaloneContent>
      </div>
    </div>
  );
};

export default StandaloneQuestionnaire;
